import {
  store
} from "./index";
const mutations = {
  resetState() {
    store.state.sidebarTabData = [];
    store.state.sidebarItemSelection = [];
    store.state.userStorage = {};
    store.state.notificationCount = undefined;
    // store.state.modalError = {}; // SEEMS TO BRAKE MODAL_ERROR
    store.state.currentTabIndex = 0;
    store.state.taskFromLink = false;
  },

  modalError(state, params) {
    store.state.modalError.active = params.active !== false;
    if (params.message !== undefined)
      store.state.modalError.message = params.message;
  },

  toastStatus(state, params) {
    store.state.toastStatus.active = params.active !== false;
    let dur = params.duration;
    store.state.toastStatus.duration =
      dur !== undefined && Number.isInteger(dur) ? dur : undefined;
    store.state.toastStatus.ok = params.ok !== undefined ? params.ok : true;
    store.state.toastStatus.message =
      params.message !== undefined ? params.message : "";
  },

  localStorage(state, params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        localStorage[key] = params[key];
      }
    });

    let name = params.name;
    let surname = params.surname;
    let email = params.email;
    store.state.userStorage = {
      name: name,
      surname: surname,
      email: email
    };
  },

  itemAddStep: () => {
    store.state.itemAction.addStep = !store.state.itemAction.addStep;
  },

  notificationCount(state, params) {
    store.state.notificationCount = params;
  },

  lastLink(state, params) {
    store.state.lastLink = params;
  },

  taskFromLink(state, params) {
    store.state.taskFromLink = params;
  },

  externalLink(state, params) {
    store.state.externalLink = params;
  }
};
export default {
  mutations
};



// WEBPACK FOOTER //
// ./src/store/mutations.js